// extracted by mini-css-extract-plugin
module.exports = {"DocsProtectionChoice__readonly":"DocsProtectionChoice_DocsProtectionChoice__readonly__2U42R","tooltip":"DocsProtectionChoice_tooltip__1xpSY"};